const UnRegisterPushNotification = () => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations()
            .then((registrations) => {
                registrations
                    .filter(registration => registration.scope.includes('firebase-cloud-messaging-push-scope'))
                    .forEach(registration => {
                        registration.unregister()
                            .then(success => {
                                if (success) {
                                    console.log('Service Worker unregistered successfully.');
                                } else {
                                    console.error('Service Worker unregistration failed.');
                                }
                            });
                    });
            })
            .catch(error => {
                console.error('Error getting Service Worker registrations:', error);
            });
    } else {
        console.error('Service Workers are not supported in this browser.');
    }
}

export default UnRegisterPushNotification